import SEO from "@/components/SEO";
import { PLANS } from "@/lib/content";
import PayPalButton from "@/components/PayPalButton";
import { Check, Star } from "lucide-react";
import { Link } from "react-router-dom";

export default function Pricing() {
  return (
    <>
      <SEO title="Pricing — Tech Alpha SSL" description="Transparent pricing for SSL Installation, Security Audits, Premium Security, and Enterprise plans." canonical="https://techalphassl.com/pricing" />
      <section className="pt-20 pb-10">
        <div className="container-page max-w-4xl">
          <span className="eyebrow">Pricing</span>
          <h1 className="mt-4 text-4xl md:text-6xl font-semibold tracking-tighter">Simple, transparent, honest.</h1>
          <p className="mt-4 text-lg text-muted-foreground">No hidden fees. No mystery renewals. Pick a plan, or request a custom quote.</p>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-page grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {PLANS.slice(0, 4).map((p) => (
            <div
              key={p.id}
              data-testid={`pricing-card-${p.id}`}
              className={`relative rounded-2xl p-8 border transition-all hover:-translate-y-1 ${
                p.popular
                  ? "bg-gradient-to-br from-[#1565FF] to-[#0e52d6] text-white border-transparent shadow-[0_20px_60px_-15px_rgba(21,101,255,0.55)] lg:scale-[1.03]"
                  : "bg-white dark:bg-white/[0.03] border-black/5 dark:border-white/10"
              }`}
            >
              {p.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 rounded-full bg-[#4FC3F7] px-3 py-1 text-xs font-medium text-[#0B1220]">
                  <Star className="h-3 w-3 fill-current" /> Most Popular
                </span>
              )}
              <h3 className={`text-lg font-semibold tracking-tight ${p.popular ? "text-white" : ""}`}>{p.name}</h3>
              <p className={`mt-1 text-sm ${p.popular ? "text-white/80" : "text-muted-foreground"}`}>{p.tagline}</p>
              <div className={`mt-6 text-4xl font-semibold tracking-tighter ${p.popular ? "text-white" : ""}`}>{p.priceLabel}</div>
              <div className={`text-xs mt-1 ${p.popular ? "text-white/70" : "text-muted-foreground"}`}>one-time</div>
              <ul className="mt-6 space-y-2">
                {p.features.map((f, i) => (
                  <li key={i} className={`flex items-start gap-2 text-sm ${p.popular ? "text-white/90" : ""}`}>
                    <Check className={`h-4 w-4 mt-0.5 ${p.popular ? "text-[#4FC3F7]" : "text-[#1565FF] dark:text-[#4FC3F7]"}`} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <PayPalButton
                  plan_id={p.id}
                  plan_name={p.name}
                  price={p.price}
                  label={p.ctaLabel}
                  className={p.popular ? "!bg-white !text-[#1565FF] hover:!bg-white/90 w-full" : "w-full"}
                  testId={`pricing-buy-${p.id}`}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Custom Enterprise */}
        <div className="container-page mt-8">
          <div className="card-elevated p-8 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-semibold tracking-tight">Custom Enterprise Solution</h3>
              <p className="mt-2 text-muted-foreground max-w-xl">
                For teams that need bespoke architecture, deep integrations, or executive-level engagement. We'll build a plan around your scope.
              </p>
            </div>
            <Link to="/quote" className="btn-primary" data-testid="pricing-contact-sales">Contact Sales</Link>
          </div>
        </div>
      </section>
    </>
  );
}
